import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2fc7d65a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2fc7d65a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc7d65a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fc7d65a')) {
      api.createRecord('2fc7d65a', component.options)
    } else {
      api.reload('2fc7d65a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2fc7d65a&scoped=true", function () {
      api.rerender('2fc7d65a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hub/TokenHub/index.vue"
export default component.exports